var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.77,
    height: 43.77,
    viewBox: "0 0 43.77 43.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2050",
    "data-name": "\\uADF8\\uB8F9 2050",
    transform: "translate(-300 -300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2047",
    "data-name": "\\uADF8\\uB8F9 2047",
    transform: "translate(300 300)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1345",
    "data-name": "\\uD328\\uC2A4 1345",
    d: "M321.885,343.77a21.885,21.885,0,1,1,21.885-21.885A21.91,21.91,0,0,1,321.885,343.77Zm0-40.644a18.759,18.759,0,1,0,18.759,18.759A18.78,18.78,0,0,0,321.885,303.126Z",
    transform: "translate(-300 -300)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2048",
    "data-name": "\\uADF8\\uB8F9 2048",
    transform: "translate(310.943 310.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1346",
    "data-name": "\\uD328\\uC2A4 1346",
    d: "M770.322,771.885a1.558,1.558,0,0,1-1.105-.458l-18.759-18.759a1.563,1.563,0,0,1,2.21-2.21l18.759,18.759a1.563,1.563,0,0,1-1.105,2.668Z",
    transform: "translate(-750 -750)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2049",
    "data-name": "\\uADF8\\uB8F9 2049",
    transform: "translate(310.943 310.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1347",
    "data-name": "\\uD328\\uC2A4 1347",
    d: "M751.563,771.885a1.563,1.563,0,0,1-1.105-2.668l18.759-18.759a1.563,1.563,0,0,1,2.211,2.21l-18.759,18.759A1.558,1.558,0,0,1,751.563,771.885Z",
    transform: "translate(-750 -750)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.01252a61b02464bff5cd184f36c264b6.svg";
export { ForwardRef as ReactComponent };